import { get, post } from '../utils/request';
import type { LoginResult } from '@shared/types';

/**
 * 认证API服务
 */
export const authService = {
  /** 登录 */
  login(username: string, password: string): Promise<LoginResult> {
    return post<LoginResult>('/auth/login', { username, password });
  },

  /** 获取当前用户信息 */
  getProfile(): Promise<any> {
    return get('/auth/profile');
  },

  /** 登出 */
  logout(): Promise<void> {
    return post('/auth/logout');
  },

  /** 修改当前用户密码 */
  changePassword(data: { old_password: string; new_password: string }): Promise<void> {
    return post('/auth/change-password', data);
  },
};
